import React, { useEffect, useState } from "react";
import { PiX, PiMinus, PiCaretUpDownFill } from "react-icons/pi";
import { useShowTempMessage } from "../../shared/hooks/useUtilityContext";
import { logAnalyticsEvent } from "../../engagement/Amplitude";

export default function SnippetConverter({
  code,
  title,
}: {
  code: string;
  title: string;
}) {
  const [snippet, setSnippet] = useState(convertCodeToSnippet() ?? "");
  const showTempMessage = useShowTempMessage();

  useEffect(() => {
    setSnippet(convertCodeToSnippet());
  }, [title, code]);

  function convertCodeToSnippet(): string {
    // Get form values
    const description = title;
    const tabTrigger = "test";

    // Generate VSCode snippet
    const snippet = `"${description}": {
    "prefix": "${tabTrigger}",
    "body": [
      ${code
        .split("\n")
        .map((line: string) => `"${line.replace(/"/g, '\\"')}"`)
        .join(",\n    ")}
    ],
    "description": "${description}"
  }`;

    console.log(snippet);
    return snippet;
  }

  return (
    <div className="w-1/2 bg-neutral p-0 rounded-md relative text-neutral-content">
      <textarea
        title="Snippet"
        className="h-full resize-none bg-transparent p-4 font-mono w-full text-base
        caret-white leading-normal outline-none overflow-x-scroll no-scrollbar whitespace-pre"
        value={snippet}
        onChange={(e) => setSnippet(e.target.value)}
      ></textarea>
      <div className="absolute bottom-4 right-4">
        <button
          title="Copy Snippet"
          className="btn btn-sm btn-primary"
          onClick={() => {
            logAnalyticsEvent("Copied VS Code Snippet");
            navigator.clipboard.writeText(snippet);
            showTempMessage("Snippet copied to clipboard!");
          }}
        >
          Copy
        </button>
      </div>
    </div>
  );
}